import React, { useEffect, useState } from 'react';
import axios from 'axios';
import api from './api';

const ConsultaCNPJ = ({ cnpj, onResult }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const consultarCNPJ = async () => {
            if (!cnpj || cnpj.length !== 14) return; // Valida o CNPJ antes de consultar
            setLoading(true);
            setError('');

            try {
                const response = await api.get(`/api/consulta-cnpj/${cnpj}`); // Faz a requisição ao backend
                onResult(response.data); // Retorna os dados para o componente pai
            } catch (err) {
                console.error('Erro na consulta:', err); // Log do erro
                setError('Erro ao consultar CNPJ. Verifique o número e tente novamente.');
                onResult(null);
            } finally {
                setLoading(false);
            }
        };

        consultarCNPJ();
    }, [cnpj, onResult]);

    return (
        <div>
            {loading && <p>Consultando CNPJ...</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
    );
};

export default ConsultaCNPJ;